import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { getAction, httpAction } from '@/api/manage';
import IwsUpload from '@comp/upload/IwsUpload';
import pick from 'lodash.pick';
import moment from 'moment';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
/*DataSource 定义数据源数组*/

var data1 = []; // PS相关的KEY不能为title关键字

var addData1Index = 0;
/*table 保险明细表头展示参数*/

var columns1 = [{
  title: '排序',
  dataIndex: '',
  key: 'rowIndex',
  width: '10%',
  align: 'center',
  customRender: function customRender(t, r, index) {
    return parseInt(index) + 1;
  }
}, {
  title: '保险险种',
  dataIndex: 'category',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'category'
  }
}, {
  title: '绝对免赔率',
  dataIndex: 'deductible',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'deductible'
  }
}, {
  title: '费率浮动',
  dataIndex: 'rate',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'rate'
  }
}, {
  title: '保险金额/责任限额',
  dataIndex: 'worth',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'worth'
  }
}, {
  title: '保险费',
  dataIndex: 'fee',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'fee'
  }
}, {
  title: '操作',
  dataIndex: 'operation',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'operation'
  }
}];
export default {
  components: {
    IwsUpload: IwsUpload
  },
  name: 'CarInsuranceModal',
  mixins: [ModalFormMixin],
  data: function data() {
    this.cacheData = data1.map(function (item) {
      return _objectSpread({}, item);
    });
    return {
      title: '车辆保险表单',
      tableName: 'ea_asset_car_insurance',
      form_fields: ['carId', 'companyId', 'total', 'fileId', 'remark', 'status', 'sort', 'userId'],
      form_fields_time: ['insureDate', 'sdate', 'edate'],
      validatorRules: {
        carId: {
          rules: [{
            required: true,
            message: '请输入车辆档案ID!'
          }]
        },
        companyId: {
          rules: [{
            required: true,
            message: '请输入保险公司!'
          }]
        },
        insureDate: {
          rules: [{
            required: true,
            message: '请输入投保时间!'
          }]
        },
        sdate: {
          rules: [{
            required: true,
            message: '请输入保险起始时间!'
          }]
        },
        edate: {
          rules: [{
            required: true,
            message: '请选择保险结束时间!'
          }]
        },
        total: {
          rules: [{
            required: true,
            message: '请输入总金额!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入保险状态!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择登记人!'
          }]
        }
      },
      carId: '',
      loginUser: '',
      carList: [],
      userTree: [],
      companyList: [],
      dateFormat: 'YYYY-MM-DD',
      disableStatus: false,
      data1: data1,
      addData1Index: addData1Index,
      columns1: columns1,
      dateData: {
        startDate: undefined,
        // 保险起始时间
        endDate: undefined // 保险结束时间

      },
      url: {
        queryCar: '/ea/asset/car/queryCarCards',
        queryCompany: '/ea/company/info/queryCompanyName',
        queryCarInsuranceItem: '/asset/car/insurance/'
      }
    };
  },
  props: {
    permissionObj: {
      type: Object,
      default: function _default() {
        edit: '';
      }
    },
    pagePath: String
  },
  created: function created() {
    this.queryUserTreeList();
    this.loginUser = this.$store.getters.userInfo.id;
    console.log('loginUser', this.loginUser);
  },
  methods: {
    moment: moment,

    /**
     * 保险期限时间
     * @param value
     * @param dateString
     */
    onDateChange: function onDateChange(value, dateString) {
      this.dateData.startDate = dateString[0] == '' ? null : dateString[0];
      this.dateData.endDate = dateString[1] == '' ? null : dateString[1];
    },
    add: function add(carId) {
      this.carId = carId;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.disableStatus = false;
      this.addData1Index = 1;
      this.data1 = [];
      this.loadCar(); //车辆

      this.loadCompany(); //厂商

      this.dateData.startDate = this.model.sdate;
      this.dateData.endDate = this.model.edate;

      if (this.model.id != null) {
        this.loadCarInsuranceItem(this.model.id);
      } else {
        if (this.carId != null) {
          this.model.carId = parseInt(this.carId);
          this.disableStatus = true;
        }
      }

      if (!this.model.userId) {
        this.model.userId = this.loginUser;
      }

      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields));
        that.form.setFieldsValue({
          insureDate: _this.model.insureDate ? moment(_this.model.insureDate) : null
        });
        that.form.setFieldsValue({
          sdate: _this.model.sdate ? moment(_this.model.sdate) : null
        });
        that.form.setFieldsValue({
          edate: _this.model.edate ? moment(_this.model.edate) : null
        });

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          if (!_this2.dateData.startDate || !_this2.dateData.endDate) {
            _this2.$message_custom('请选择保险期限', 'error');

            return;
          }

          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.sdate = that.dateData.startDate;
          formData.edate = that.dateData.endDate; // 投保时间

          formData.insureDate = formData.insureDate ? formData.insureDate.format('YYYY-MM-DD') : null;
          formData.items = _this2.data1;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';
          var headers = {
            tableName: _this2.permissionObj.edit.split(':')[1]
          };

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';

            if (_this2.permissionObj.edit) {
              headers.id = _this2.model.id; // let largePermission = getLargePermission({ value: that.permissionObj.edit })
              // getBindingValue(headers, largePermission)
            }
          }

          httpAction(httpurl, formData, method, headers).then(function (res) {
            if (res.success) {
              _this2.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    loadCar: function loadCar() {
      var that = this;
      that.carList = [];
      getAction(this.url.queryCar).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this3 = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this3.loading = false;
        }
      });
    },
    loadCarInsuranceItem: function loadCarInsuranceItem(params) {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCarInsuranceItem + params).then(function (res) {
        if (res.success) {
          var paramList = [];

          for (var i = 0; i < res.result.items.length; i++) {
            var param = res.result.items[i];
            param.key = param.id;
            param.editable = false;
            paramList.push(param);
          }

          that.data1 = paramList;
        }
      });
    },

    /**
     * 新增车辆保险明细数组
     */
    addTable: function addTable() {
      var newData = _toConsumableArray(this.data1);

      newData.push({
        key: 'A1_' + this.addData1Index,
        userName: '',
        projectRole: '',
        editable: true
      });
      this.addData1Index = this.addData1Index + 1;
      this.data1 = newData;
      this.cacheData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },

    /**
     * table行删除
     * @param key
     */
    delTable1: function delTable1(key) {
      var newData = this.data1.filter(function (item) {
        return key != item.key;
      });
      this.data1 = newData;
      this.cacheData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};